// 목데이터용 사역 포트폴리오 이미지 — 설교/찬양 영상 썸네일(16:9), 사역사진(4:3)을 SVG 일러스트 data URI 로 생성

function toDataUri(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.replace(/\s+/g, ' '))}`;
}

function pick<T>(list: T[], n: number) {
  return list[n % list.length];
}

// 사람 실루엣 (머리+몸)
function person(x: number, baseY: number, scale: number, color: string) {
  const r = 11 * scale;
  return `<circle cx="${x}" cy="${baseY - 46 * scale}" r="${r}" fill="${color}"/>
    <path d="M${x - 17 * scale} ${baseY} Q${x - 17 * scale} ${baseY - 32 * scale} ${x} ${baseY - 32 * scale} Q${x + 17 * scale} ${baseY - 32 * scale} ${x + 17 * scale} ${baseY}Z" fill="${color}"/>`;
}

const SERMON_BG = [['#3a2a1e', '#1a120c'], ['#1f2a3a', '#0e141d'], ['#2e2a26', '#141210']];

export function mockSermonThumb(n: number) {
  const [top, bottom] = pick(SERMON_BG, n);
  return toDataUri(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 180">
    <defs>
      <linearGradient id="b" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${top}"/><stop offset="1" stop-color="${bottom}"/></linearGradient>
      <radialGradient id="l" cx="0.5" cy="0.35" r="0.5"><stop offset="0" stop-color="#ffe2b0" stop-opacity="0.45"/><stop offset="1" stop-color="#ffe2b0" stop-opacity="0"/></radialGradient>
    </defs>
    <rect width="320" height="180" fill="url(#b)"/>
    <rect width="320" height="180" fill="url(#l)"/>
    <rect x="${n % 2 ? 250 : 58}" y="28" width="6" height="52" fill="#d9c29a" opacity="0.7"/>
    <rect x="${n % 2 ? 237 : 45}" y="42" width="32" height="6" fill="#d9c29a" opacity="0.7"/>
    ${person(160, 128, 1.25, '#0b0907')}
    <path d="M128 180 L136 118 L184 118 L192 180Z" fill="#5a3f2a"/>
    <rect x="132" y="114" width="56" height="8" rx="2" fill="#6e4f36"/>
  </svg>`);
}

const WORSHIP_LIGHTS = ['#7b5cff', '#ff5c8a', '#2fb3ff', '#ffb02f'];

export function mockWorshipThumb(n: number) {
  const light = pick(WORSHIP_LIGHTS, n);
  const light2 = pick(WORSHIP_LIGHTS, n + 2);
  return toDataUri(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 180">
    <rect width="320" height="180" fill="#0c0b16"/>
    <path d="M60 0 L20 180 L110 180Z" fill="${light}" opacity="0.28"/>
    <path d="M160 0 L120 180 L200 180Z" fill="${light2}" opacity="0.22"/>
    <path d="M260 0 L210 180 L300 180Z" fill="${light}" opacity="0.28"/>
    <circle cx="60" cy="6" r="6" fill="${light}"/><circle cx="160" cy="6" r="6" fill="${light2}"/><circle cx="260" cy="6" r="6" fill="${light}"/>
    <rect x="0" y="150" width="320" height="30" fill="#17151f"/>
    ${person(80, 152, 0.9, '#050409')}
    ${person(240, 152, 0.9, '#050409')}
    ${person(160, 152, 1.15, '#050409')}
    <line x1="${160 + 26}" y1="152" x2="${160 + 26}" y2="104" stroke="#050409" stroke-width="3"/>
    <circle cx="${160 + 22}" cy="102" r="4" fill="#050409"/>
    <rect x="${n % 2 ? 214 : 54}" y="120" width="52" height="30" rx="3" fill="#050409"/>
  </svg>`);
}

const PHOTO_SCENES = [
  { sky: ['#9fd3ff', '#e2f3ff'], ground: '#7cc36b' }, // 야외 수련회
  { sky: ['#fff1d6', '#ffe4b8'], ground: '#c9a27a' }, // 교육관 실내
  { sky: ['#ffd1c2', '#ffeede'], ground: '#8fb46d' }, // 노을
  { sky: ['#dfe7f2', '#f4f7fb'], ground: '#b7c0cc' }, // 예배당
];
const SHIRTS = ['#ff8a65', '#4db6ac', '#7986cb', '#ffd54f', '#e57373', '#81c784', '#64b5f6', '#ba68c8'];

export function mockMinistryPhoto(n: number) {
  const scene = pick(PHOTO_SCENES, n);
  const count = 5 + (n % 3);
  const gap = 240 / (count - 1);
  let people = '';
  for (let i = 0; i < count; i++) {
    const x = 40 + gap * i;
    const back = i % 2 === 1;
    people += person(x, back ? 176 : 196, back ? 0.95 : 1.1, pick(SHIRTS, n + i));
  }
  const banner = n % 2 === 0
    ? `<rect x="90" y="30" width="140" height="30" rx="4" fill="#fff" opacity="0.9"/><rect x="104" y="42" width="112" height="6" rx="3" fill="#c7cbd6"/>`
    : `<circle cx="${n % 4 === 1 ? 262 : 58}" cy="46" r="18" fill="#fff6c9" opacity="0.9"/>`;
  return toDataUri(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 240">
    <defs><linearGradient id="s" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${scene.sky[0]}"/><stop offset="1" stop-color="${scene.sky[1]}"/></linearGradient></defs>
    <rect width="320" height="240" fill="url(#s)"/>
    ${banner}
    <rect x="0" y="160" width="320" height="80" fill="${scene.ground}"/>
    ${people}
  </svg>`);
}
